import { ScrollArea } from '@/components/ui/scroll-area'

export const AboutSection = () => {
  return (
    <div className="h-full flex flex-col animate-fade-in p-4">
      <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4 border-b-2 border-gray-400 pb-2">
        Sobre o Banco da Sucata
      </h2>
      <ScrollArea className="flex-1 pr-4 retro-bevel-inset p-4 bg-white">
        <div className="prose prose-lg font-serif text-gray-800 max-w-none">
          <p className="mb-4">
            Fundado com a missão de revolucionar o mercado de reciclagem
            industrial, o<strong> Banco da Sucata</strong> é líder na gestão,
            compra e processamento de resíduos metálicos.
          </p>
          <p className="mb-4">
            Operando com tecnologia de ponta e processos sustentáveis,
            transformamos o que antes era considerado apenas "sucata" em
            matéria-prima nobre para a indústria siderúrgica e de fundição.
            Nossa estrutura permite o atendimento ágil a grandes geradores,
            oferecendo logística própria e pagamento garantido.
          </p>
          <h3 className="text-xl font-bold mt-6 mb-2">Nossa Infraestrutura</h3>
          <ul className="list-disc pl-6 mb-4">
            <li>Pátio de processamento de 5.000m²</li>
            <li>Frota própria de caminhões Munck e Roll-on/Roll-off</li>
            <li>Balanças rodoviárias digitais de precisão</li>
            <li>Equipe especializada em classificação de ligas</li>
          </ul>
          <p>
            Ao escolher o Banco da Sucata, você não está apenas vendendo
            material; você está participando ativamente da economia circular e
            contribuindo para um futuro mais limpo.
          </p>
        </div>
      </ScrollArea>
    </div>
  )
}
